// material-ui
// import Badge from '@mui/material/Badge';

// project-imports
// import Avatar from 'components/@extended/Avatar';

// ==============================|| CHAT - USER AVATAR WITH STATUS ICON ||============================== //

export default function UserAvatar({ url, team }: any) {
  return (<></>
    // <Badge
    //   overlap="circular"
    //   anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    //   sx={{ '& .MuiBox-root': { width: 6, height: 6 }, padding: 0, minWidth: 12, '& svg': { bgcolor: '#fff', borderRadius: '50%' } }}
    // >
    //   <Avatar sx={{ '& img': { width: '40px', height: 'auto' } }} alt={team?.name} />
    // </Badge>
  );
}
